import React from 'react';

const ContactSection: React.FC = () => {
  return (
    <section className="contact-section">
      <div className="contact-container">
        <h2 className="section-title">CONTACT ME</h2>
        
        <div className="contact-content">
          <div className="contact-info">
            <div className="info-item">
              <h3 className="info-title">Get In Touch</h3>
              <p className="info-text">Feel free to reach out if you're looking for a developer, have a question, or just want to connect.</p>
            </div>
            
            <div className="info-item">
              <h3 className="info-title">Contact Details</h3>
              <p className="info-text">Email: silvajosh55@gmail.com</p>
              <p className="info-text">Phone: (407) 952-0984</p>
              <p className="info-text">Location: Davenport, Florida</p>
            </div>
          </div>
          
          <div className="contact-form-container">
            <form className="contact-form">
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input type="text" id="name" placeholder="Your Name" />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" placeholder="Your Email" />
              </div>
              
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input type="text" id="subject" placeholder="Subject" />
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea id="message" rows={5} placeholder="Your Message"></textarea>
              </div>
              
              <button type="submit" className="submit-button">SEND MESSAGE</button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection; 